import React from 'react';

const PageErrorMessage = props => {
    const { errorMessage } = props;

    const setError = () => {
        return { __html: errorMessage };
    };

    if (!errorMessage) {
        return <div></div>;
    }

    return <div className="app__page-error" dangerouslySetInnerHTML={setError()}></div>;
};

export default PageErrorMessage;
